<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";

import TabKompetensiProfesi from "./components/tab-kompetensi-profesi.vue";

export default {
  components: {
    Layout,
    PageHeader,
		TabKompetensiProfesi,
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">

				<b-tabs class="honor-tabs" nav-class="nav-tabs-custom">
					<b-tab title="Kompetensi Dalam Profesi" active>
						<TabKompetensiProfesi />
					</b-tab>
					<b-tab title="Kompetensi Sisa">
						<TabKompetensiProfesi />
					</b-tab>
				</b-tabs>
      </div>
    </div>
  </Layout>
</template>
